export function defaultRouteForRole(role) {
  if (role === 'admin' || role === 'operator') return '/home';
  if (role === 'user' || role === 'guest') return '/portal';
  return '/login';
}

export function navItemsForRole(role) {
  if (role === 'admin') {
    return [
      { to: '/home', label: 'Панель' },
      { to: '/portal', label: 'Портал клиента' },
      { to: '/streams', label: 'Трансляции' },
      { to: '/reports', label: 'Отчеты' },
      { to: '/admin', label: 'Админка' },
      { to: { path: '/admin', query: { tab: 'users' } }, label: 'Онлайн' },
    ];
  }

  if (role === 'operator') {
    return [
      { to: '/home', label: 'Панель' },
      { to: '/streams', label: 'Трансляции' },
      { to: '/reports', label: 'Отчеты' },
    ];
  }

  if (role === 'user' || role === 'guest') {
    return [
      { to: '/portal', label: 'Мои трансляции' },
      { to: '/my-objects', label: 'Мои объекты' },
      { to: '/reports', label: 'Отчеты' },
    ];
  }

  return [];
}
